export const CIVILITIES = {
  MR: 'mr',
  MRS: 'mrs',
  OTHER: 'other'
} as const;

export const COUNTRIES = {
  AUSTRIA: 'AT',
  BELGIUM: 'BE',
  ENGLAND: 'EN',
  FRANCE: 'FR',
  GERMANY: 'DE',
  GREECE: 'GR',
  HONGKONG: 'HK',
  IRELAND: 'IE',
  ITALY: 'IT',
  LUXEMBOURG: 'LU',
  MONACO: 'MC',
  NETHERLANDS: 'NL',
  PORTUGAL: 'PT',
  SCHWEIZ: 'CH',
  SINGAPORE: 'SG',
  SPAIN: 'ES',
  UNITED_KINGDOM: 'GB',
  USA: 'US',
} as const;
